import { animate, group, query, stagger, style, transition, trigger } from '@angular/animations';

export const groupStagger = trigger('groupStaggerAnimation', [
    transition('* => *', [
        query(
            ':enter',
            [
                style({
                    opacity: 0,
                    transform: 'translateX(-5%)',
                }),
                stagger(50, [
                    group([
                        animate(
                            400,
                            style({
                                opacity: 1,
                            }),
                        ),
                        animate(
                            200,
                            style({
                                transform: 'translateX(0)',
                            }),
                        ),
                    ]),
                ]),
            ],
            { optional: true },
        ),
    ]),
]);
